import { API_HOST } from '../../config';

const BASE = `${API_HOST}/api/v1/ai-chat`;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('access')}`,
});

const asJson = async (response) => {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.detail || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return body;
};

export const fetchConfig = () =>
  fetch(`${BASE}/config`, { headers: authHeaders() }).then(asJson);

export const fetchSkills = () =>
  fetch(`${BASE}/skills`, { headers: authHeaders() }).then(asJson);

export const listConversations = () =>
  fetch(`${BASE}/conversations`, { headers: authHeaders() }).then(asJson);

export const createConversation = () =>
  fetch(`${BASE}/conversations`, { method: 'POST', headers: authHeaders() }).then(asJson);

export const getConversation = (id) =>
  fetch(`${BASE}/conversations/${id}`, { headers: authHeaders() }).then(asJson);

export const deleteConversation = (id) =>
  fetch(`${BASE}/conversations/${id}`, { method: 'DELETE', headers: authHeaders() }).then(
    asJson
  );

/*
 * Open the streaming reply.
 *
 * Deliberately fetch + ReadableStream rather than EventSource: EventSource
 * cannot set an Authorization header, and this API is bearer-JWT only. The
 * caller gets the raw Response and parses frames itself (see useChatStream).
 */
export const openMessageStream = (conversationId, message, model, signal) =>
  fetch(`${BASE}/conversations/${conversationId}/messages`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ message, model }),
    signal,
  });

export const MESSAGES_BASE = BASE;
